<template>
    <form :class="classes" method="post" @submit.prevent="submit">
        <div class="form__loading" v-if="loading"><div class="loader"><span></span><span></span><span></span></div></div>

        <div v-if="success && successMessage" class="form__success" v-html="successMessage"></div>

        <slot :data="fields" :errors="errors" v-if="!loading" :file="file" />
    </form>
</template>

<script>
export default {
    name: 'FormComponent',

    props: {
        handle: {
            type: String,
            required: true
        },
        recaptchaCode: {
            type: String,
            required: true
        },
        successMessage: {
            type: String,
            required: true
        },
        classes: {
            type: String,
            required: false,
            default: 'form mb-12'
        },
        values: {
            type: Object,
            required: false,
            default: () => ({ })
        },
    },

    data: () => ({
        fields: {},
        errors: {},
        success: false,
        loading: false,
    }),

    mounted() {
        if(this.values && Object.keys(this.values).length > 0) {
            for(let key in this.values) {
                this.fields[key] = this.values[key];
            }
        }
    },

    methods: {
        submit() {
            this.loading = true;
            this.errors = {};
            this.success = false;

            grecaptcha.ready(() => {
                grecaptcha.execute(this.recaptchaCode, { action: 'submit' })
                    .then(token => {
                        let form = new FormData;

                        form.append('handle', this.handle);

                        for (let key in this.fields) {
                            form.append('fields[' + key + ']', this.fields[key]);
                        }

                        form.append('recaptcha_token', token);

                        BananaMoon.request().post('/ajax/form', form)
                            .then(response => {
                                this.loading = false;
                                this.success = true;

                                if (this.handle == 'brochure') {
                                    window.location.href = '/brochure';
                                }

                                // if (this.handle == 'contact-us') {

                                //     if (window.gtagID) {
                                //         window.gtag('config', window.gtagID, { 'page_path': '/contact-thank-you' });
                                //     } else {
                                //         //
                                //     }
                                //     // window.gtag('config', window.gtagID, { 'page_path': '/contact-thank-you' });
                                // } else if (this.handle == 'callback') {
                                //     window.gtag('config', window.gtagID, { 'page_path': '/callback-thank-you' });
                                // }

                                if (response.status === 200) {
                                    this.emitGTMEvent(response.data.service);
                                }

                                this.reset();
                            })
                            .catch(error => {
                                if (typeof error.response.data.errors != 'undefined') {
                                    this.errors = error.response.data.errors;
                                }

                                if ( error.response.data.message === 'Failed with checks.' ) {
                                    this.errors.recaptcha_score = 'Verification unsuccessful. Please refresh the page or disable any ad-blockers to continue.';
                                }

                                this.$nextTick(() => {
                                    this.loading = false;
                                });
                            });
                    })
                    .catch(error => {
                        console.error('reCAPTCHA execution error:', error);
                        // Handle reCAPTCHA execution error if necessary
                        this.loading = false; // Update loading state accordingly
                    });
                });
            },
        reset() {
            for(let key in this.fields) {
                if(typeof this.values[key] == 'undefined') {
                    this.fields[key] = '';
                }
            }
        },
        emitGTMEvent(event) {
            if (window.dataLayer) {
                window.dataLayer.push({
                    'event': event,
                });
            } else {
                console.log(event);
            }
        },
        file(e, key) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.fields[key] = files[0];
        }
    }
}
</script>

<style scoped>
    .loader{
        width: 100px;
        height: 100px;
        border-radius: 100%;
        position: relative;
    }

    .loader span{
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 100%;
        background-color: #ffffff;
        margin: 35px 5px;
        opacity: 0;
    }

    .loader span:nth-child(1){
        animation: opacitychange 1s ease-in-out infinite;
    }

    .loader span:nth-child(2){
        animation: opacitychange 1s ease-in-out 0.33s infinite;
    }

    .loader span:nth-child(3){
        animation: opacitychange 1s ease-in-out 0.66s infinite;
    }

    @keyframes opacitychange{
        0%, 100%{
            opacity: 0;
        }

        60%{
            opacity: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// Form.vue?3977cc68